import { createSelector } from 'reselect';
import { differenceInDays } from 'date-fns';
import { IBookingManagerDashboardSubdomain } from './model';
import { dashboardSubdomainSelector } from '../../selectors';
import { ITopNavigationData } from 'services/BookingManagerApi';
import { DAYS_AFTER_LAST_CHECKOUT_DISABLE_SR_EDITING } from 'config';

export const specialRequestsDashboardSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.specialRequests
);

export const topNavigationDataDashboardSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.topNavigationData
);

export const isCheckoutEditingWindowClosedSelector = createSelector(
  topNavigationDataDashboardSelector,
  (topNavigationData: ITopNavigationData | null) => {
    const checkoutDate = topNavigationData?.departureDate;
    if (!checkoutDate) {
      return false;
    }

    return differenceInDays(new Date(Date.now()), new Date(checkoutDate)) > DAYS_AFTER_LAST_CHECKOUT_DISABLE_SR_EDITING;
  }
);

export const dashboardNetworkRequestsSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.networkRequests
);

export const isSpecialRequestsEditedWithoutSavingSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.isSpecialRequestsEditedWithoutSaving
);

export const bookingTypeSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.bookingType
);

export const bookingInformationReservationTeamDashboardSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.bookingInformationReservationTeamData
);

export const bookingTasksSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.bookingTasks
);

export const bookingTasksRequestSelector = createSelector(
  dashboardSubdomainSelector,
  (subdomain: IBookingManagerDashboardSubdomain) => subdomain.networkRequests.bookingTasksLoad
);
